<template>
    <div>
        <Header :notHome="true"></Header>
        <pageNav :breadcrumbsList="breadcrumbsList" :showBanner="false" :isDetail="true"></pageNav>
        <div class="main-content-area">
        <div class="detail-area" ref="detailArea">
            <div class="detail-bg">
                <div class="bg-img">
            <img src='../../assets/image/bg33.png' class="d-sm-none d-xl-block" />
            <img src='../../assets/image/bg34.png' class="d-sm-block d-xl-none" />
          </div>
            </div>
            <div class="detail-box">
                <div class="detail-title">
                    {{ detail.title }}
                </div>
                <div class="detail-date flex justify-between">
                    <span>{{ detail.createTime.substring(0,10).replace(/-/g,'/') }}</span>
                    <span>{{ detail.department+'-'+detail.post }}</span>
                </div>
                <div class="detail-content ql-editor">
                    <!-- <p> -->
                       <div v-html="detail.content"></div>
                    <!-- </p> -->
                </div>
            </div>
        </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import {getRecruitDetail} from "@/api/recruit"
export default {
    data(){
        return{
            breadcrumbsList: [{
                title: '首页',
                url:'/'
            }, {
                title: '人才招聘',
                url:'/recruit'
            }, {
                title: '岗位详情'
            }],
            recruitId:null,
            detail:{
                createTime:''
            },
        }
    },
    mounted(){
        this.countViewCount()
        // recruitId
        let temp=['人才招聘','结果公示']
        let obj={...this.breadcrumbsList[1]}
        obj.title=temp[this.$route.query.type]
        obj.url='/recruit?to='+this.$route.query.type
        this.breadcrumbsList.splice(1,1,obj)
        if(this.$route.query.type==1){
            let tempObj=this.breadcrumbsList[2]
            tempObj.title='公示详情'
            this.breadcrumbsList.splice(2,1,obj)
        }
        // this.$nextTick(()=>{
        //     this.offsetTop=this.$refs.detailArea.offsetTop
        // })
        this.recruitId=this.$route.query.id
        // this.detail=this.getStore({name:'recruitDetail'})
        // if(this.recruitId!=this.detail.recruitId){
        //     this.$message.error('详情与Id匹配错误!请重新选择')
        //     this.$router.replace({path:'/recruit'})
        //     return
        // }
        this.getDetail()
    },
    methods:{
        getDetail(){
            getRecruitDetail({recruitId:this.recruitId}).then(res=>{
                if(res.code==200){
                    this.detail={...res.data}
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.detail-area{
    min-height: 100vh;
    .detail-bg{
        width: 100%;
    z-index: -1;
    position: fixed;
    min-height: calc(100vh - 524px);
    top: 160px;
    
    }
    .detail-box{
        max-width: 1000px;
        padding: 0 10px;
        min-height: calc(100vh - 524px);
        margin: 0 auto;
        padding-bottom: 60px;
        .detail-title{
            padding-top: 60px;
            font-family: 'SourceHanSansCN-Regular';
            font-weight: bold;
font-size: 48px;
color: #333333;
line-height: 72px;
        }
        .detail-date{
            font-family: 'SourceHanSansCN-Regular';
font-weight: 400;
font-size: 20px;
color: #999999;
line-height: 30px;
margin-top: 20px;
margin-bottom: 60px;
        }
        .detail-content{
.test-img{
    width: 100%;
    text-align: center;
    margin: 40px 0;
    img{
        max-width: 435px;
    }
}
        }
    }
}
@media (min-width: 576px)and (max-width:1200px){
    .detail-bg{
  height: calc(100vh - 524px)!important;
}
.detail-box{
    padding: 0 24px!important;
}
}
</style>